export const visit = (vm, at) => {
vm(require("./breeze-setup-prospecting-agent/en.lyaml"));
vm(require("./connect-inbox-render-modal/en.lyaml"));
vm(require("./scaled-rescue-promo/en.lyaml"));
at({ "en": { "htmlTitle": "HubSpot" } });
};